import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';
import Hero from '../sections/Hero';
import About from '../sections/About';
import Services from '../sections/Services';
import Solutions from '../sections/Solutions';
import Products from '../sections/Products';
import Industries from '../sections/Industries';
import CaseStudies from '../sections/CaseStudies';
import Insights from '../sections/Insights';
import dpImg from '../assets/end to end DP.webp';
import './HomePage.css';

interface HomePageProps {
  onBookConsultation: () => void;
  onRequestDemo: (productName: string) => void;
  onApply: () => void;
}

export const HomePage: React.FC<HomePageProps> = ({
  onRequestDemo,
}) => {
  return (
    <div className="home-page">
      <Hero />
      <About />
      <Services preview={false} />
      <Solutions preview={false} />
      <Products preview={false} onRequestDemo={onRequestDemo} />
      <Industries preview={false} />
      <CaseStudies preview={false} />
      <Insights preview={false} />

      {/* ════════════ END-TO-END DELIVERY PROCESS ════════════ */}
      <section className="about-process-section" aria-label="Our Delivery Process">
        <div className="container">
          {/* Header removed as requested */}
          <div className="process-image-container" style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '0' }}>
            <img loading="lazy" src={dpImg} alt="End-to-End Delivery Process" width="1601" height="849" style={{ maxWidth: '100%', maxHeight: '450px', width: 'auto', height: 'auto', borderRadius: '12px', objectFit: 'contain' }}  title="Vivify Soft Tech" />
          </div>
        </div>
      </section>

      {/* ════════════ FINAL CTA FROM ABOUT PAGE ════════════ */}
      <section className="about-cta-section home-cta-section" aria-label="Contact Call to Action">
        <div className="about-cta-glow" />
        <div className="container about-cta-inner">
          <div className="about-section-eyebrow" style={{ justifyContent: 'center', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem', textTransform: 'uppercase' }}>
            <CheckCircle size={14} className="cta-check-icon" /> YOUR DIGITAL TRANSFORMATION STARTS HERE
          </div>
          <h2 className="about-cta-title">
            Build the Future with Intelligent Technology
          </h2>
          <p className="about-cta-desc">
            Partner with Vivify Soft Tech to transform your business with AI-powered solutions, cloud systems, and intelligent automation that drive real results.
          </p>
          <div className="about-cta-actions">
            <Link to="/contact" className="about-hero-primary-btn">
              <strong>Reach Vivify</strong> <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
